import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '../../../../../graphql/hooks';
import { GET_DISCOUNT, UPDATE_DISCOUNT, REMOVE_DISCOUNT, GET_DISCOUNTS } from '../../../graphql';
import Query from '../../../../../graphql/Query';
import { routePaths } from '../../../../../routePaths';
import { OnSubmit, UpdateDiscountProps, UpdateDiscountFormQueryProps } from '../types';
import DiscountForm from '../DiscountForm';
import { EditFormLayout } from '../../../../../ui-kit';

const UpdateDiscountForm = ({ discountId }: UpdateDiscountProps) => {
    const [updateDiscount] = useMutation(UPDATE_DISCOUNT);
    const { t } = useTranslation();

    const [remove] = useMutation(
        REMOVE_DISCOUNT,
        { refetchQueries: [{ query: GET_DISCOUNTS }] }
    );

    const { push: navigate } = useHistory();

    const onSubmit: OnSubmit = async values => {
        try {
            await updateDiscount({ variables: values });
            navigate(routePaths.discounts);
        } catch (error) {
            // nothing we can do
        }
    };

    const onRemove = async () => {
        try {
            await remove({ variables: { id: discountId } });
            navigate(routePaths.discounts);
        } catch (error) {
            // nothing we can do
        }
    };

    return (
        <Query<UpdateDiscountFormQueryProps> query={GET_DISCOUNT} variables={{ id: discountId }}>
            {({ data: { discount } }) => {

                const initialValues = discount;
                return (
                    <EditFormLayout
                        onRemove={onRemove}
                        title={t('Update Discount')}
                        buttonText={t('Remove Discount')}
                    >
                        <DiscountForm
                            submitText={t('Update')}
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                        />
                    </EditFormLayout>
                );}}
        </Query>
    );
};

export default UpdateDiscountForm;
